import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaHelpers from "utilities/helpers/helpers-sparta/2.3.6/js/helpers-sparta";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import radioButton from "utilities/helpers/helpers-radio-button/4.3.5/js/helpers-radio-button";
import spartaTemplates from "modules/login/ah-caw-dp-module/6.3.0/js/templates";
import "css!modules/login/ah-caw-dp-module/6.3.0/css/ah-caw-dp-module.scss.css";
export default class ahCawDpView {
  constructor(parentModule) {
    this.parentModule = parentModule;

    const self = this;
    this.bindThisConext(['_initialize'], self, '');
  }

  bindThisConext(methods, context, suffix = 'Scoped') {
    const self = context;

    if (methods && $.isArray(methods) && methods.length > 0) {
      $(methods).each((index, method) => {
        if (self[method]) {
          self[method + suffix] = self[method].bind(context);
        } else {
          console.log(`Method: ${method} Not found in current context.`);
        }
      });
    }
  }

  _defineVars() {
    const _view = this.parentModule.view;
    this.$moduleContext = $(_view.settings.target);
    const elementsID = {
      'main-container': 'ah-dp-container',
      validateDp: 'validate-dp',
    };

    const elementsClass = {};

    this.elementsSelectors = {};

    $.each(elementsID, (i, val) => {
      this.elementsSelectors[i] = `#${val}`;
    });
    $.each(elementsClass, (i, val) => {
      this.elementsSelectors[i] = `.${val}`;
    });



    return this;
  }

  _bindEventHandlers() {
    const main = this.parentModule;
    const that = this;
    this.$moduleContext
      .find(this.elementsSelectors.validateDp)
      .off('click.validateDpData')
      .on('click.validateDpData', () => {
        var selectedVal = $("input[name='recordDevicePreferencesRadio']:checked").val();
        const widgetInfo = main.Store.getData('widgetConfigData');
        this.$moduleContext.find(this.elementsSelectors.validateDp).attr("disabled", "disabled");
        if (widgetInfo && widgetInfo.domain) {
          main.apiEndPoints = ahCawCommons.getEndPoints(main.endpoints, widgetInfo.domain);
        }
        main.apiEndPoints.recordDevicePreferencesUrl = main.apiEndPoints.recordDevicePreferencesUrl.substring(
          main.apiEndPoints.recordDevicePreferencesUrl.indexOf('https', 6),
        );
        const inputJson = {
          channel: 'Desktop',
          registerDevice: selectedVal,
          source: '',
          traceid: '',
        };

        const ajaxOptions = {
          method: 'POST',
          data: JSON.stringify(inputJson),
          url: main.apiEndPoints.recordDevicePreferencesUrl,
          crossDomain: true,
          cache: false,
          timeout: 60000,
          processData: false,
          xhrFields: {
            withCredentials: true,
          },
          dataType: 'json',
          headers: {
            'content-type': 'application/json',
            clientAIT: '41339',
            accept: 'application/json',
            'cache-control': 'no-cache',
          },
        };
        const initiateCall = new ahCawTransportUtility();
        initiateCall._serviceCall(
          ajaxOptions,
          function (response) {
            let data = response.responseData;
            data.successCallback = main.callbackTarget;
            main.Events.pub(cawEventsMasterUtility.EVENTS.DP_SUCCESS, data);
          },
          function (errorData) {

            that.$moduleContext.find(that.elementsSelectors.validateDp).removeAttr("disabled");
          },
        );
      });


        const basePath = ahCawCommons.getBasePath(main.spaParams);

    $(main.settings.$target)
      .find('[data-href-open]')
      .off('click')
      .on('click', function () {
        window.open(basePath + $(this).attr('data-href-open'), '');      
      });

    return this;
  }

  _redraw(event, data) {
    const main = this.parentModule;
    this.$moduleContext.find(this.elementsSelectors['main-container']).removeClass('hidden');
  }

  _listen() {
    const _view = this.parentModule.view;
    _view.listen({ context: 'PAINT-DP-MODULE', caller: this, callback: this._redraw });
    return this;
  }

  _initialize() {
    this._defineVars()._bindEventHandlers()._listen();


    $('#caw-modal-contentSpartaUILayerClose').focus();
  }
}
